var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.507 19.297a1 1 0 0 0-1.014 0L7.1 21.883c-.74.436-1.65-.203-1.49-1.047l1.01-5.342a1 1 0 0 0-.286-.902l-3.842-3.736a1 1 0 0 1 .573-1.71l5.107-.636a1 1 0 0 0 .792-.59l2.12-4.832c.35-.797 1.48-.797 1.83 0l2.12 4.831a1 1 0 0 0 .792.591l5.107.637a1 1 0 0 1 .573 1.71l-3.842 3.735a1 1 0 0 0-.285.902l1.009 5.342c.16.844-.75 1.483-1.49 1.047l-4.392-2.585Z",
    fill: "#F9C117"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.507 19.297a1 1 0 0 0-1.014 0L31.1 21.883c-.74.436-1.65-.203-1.49-1.047l1.01-5.342a1 1 0 0 0-.286-.902l-3.842-3.736a1 1 0 0 1 .573-1.71l5.107-.636a1 1 0 0 0 .792-.59l2.12-4.832c.35-.797 1.48-.797 1.83 0l2.12 4.831a1 1 0 0 0 .792.591l5.107.637a1 1 0 0 1 .573 1.71l-3.842 3.735a1 1 0 0 0-.285.902l1.009 5.342c.16.844-.75 1.483-1.49 1.047l-4.392-2.585Z",
    fill: "#F9C117"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.507 19.297a1 1 0 0 0-1.014 0L55.1 21.883c-.74.436-1.65-.203-1.49-1.047l1.01-5.342a1 1 0 0 0-.286-.902l-3.842-3.736a1 1 0 0 1 .573-1.71l5.107-.636a1 1 0 0 0 .792-.59l2.12-4.832c.35-.797 1.48-.797 1.83 0l2.12 4.831a1 1 0 0 0 .792.591l5.107.637a1 1 0 0 1 .573 1.71l-3.842 3.735a1 1 0 0 0-.286.902l1.01 5.342c.16.844-.75 1.483-1.49 1.047l-4.392-2.585Z",
    fill: "#F9C117"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.507 19.297a1 1 0 0 0-1.014 0L79.1 21.883c-.74.436-1.65-.203-1.49-1.047l1.01-5.342a1 1 0 0 0-.286-.902l-3.842-3.736a1 1 0 0 1 .573-1.71l5.107-.636a1 1 0 0 0 .792-.59l2.12-4.832c.35-.797 1.48-.797 1.83 0l2.12 4.831a1 1 0 0 0 .792.591l5.107.637a1 1 0 0 1 .573 1.71l-3.842 3.735a1 1 0 0 0-.286.902l1.01 5.342c.16.844-.75 1.483-1.49 1.047l-4.392-2.585Z",
    fill: "#F9C117"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.507 19.297a.999.999 0 0 0-1.014 0l-4.392 2.585c-.74.436-1.649-.203-1.49-1.047l1.009-5.342a.997.997 0 0 0-.285-.902l-3.842-3.736a1 1 0 0 1 .573-1.71l5.107-.636c.349-.044.65-.268.792-.59l2.119-4.832c.35-.797 1.482-.797 1.832 0l2.119 4.831c.142.323.443.547.792.591l5.107.637a1 1 0 0 1 .573 1.71l-3.842 3.735a.997.997 0 0 0-.285.902l1.009 5.342c.159.844-.75 1.483-1.49 1.047l-4.392-2.585Z",
    fill: "#F9C117"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(48)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(72)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(96)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgStars;